import ToastV2 from '@shared/components/base/BaseToast';
import i18n from '@shared/i18n/index';

import { LOGGER_SPACIAL_SYMBOL } from '../config';
import logger from '../logger';

/**
 * 全局 Promise 未捕获异常处理
 * @param e
 */
export const handleOnUnhandledrejection = (e: PromiseRejectionEvent) => {
	if (!e) return;
	const { reason } = e;
	// 判断是否是懒加载的 chunk 资源加载失败
	if (reason && reason.name === 'ChunkLoadError') {
		ToastV2.error(i18n.get('Module_Loading_Failed_Toast'));
	}

	logger.error(LOGGER_SPACIAL_SYMBOL.GLOBAL, 'PROMISE_ERROR', e.reason);
};
